import { render, staticRenderFns } from "./AdyenMerchantPanel.vue?vue&type=template&id=67650f18"
import script from "./AdyenMerchantPanel.vue?vue&type=script&lang=ts"
export * from "./AdyenMerchantPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports